import { createSlice } from "@reduxjs/toolkit";

// Initial state for commonSlice reducer
const initialState = {
  webUserColumns: [],
  selectedWebUserColumns: [],
  subAdminColumns: [],
  selectedSubAdminColumns: [],
};

// Create commonSlice reducer
const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    setWebUserColumns: (state, action) => {
      state.webUserColumns = action.payload;
    },
    setSelectedWebUserColumns: (state, action) => {
      state.selectedWebUserColumns = action.payload;
    },
    setSubAdminColumns: (state, action) => {
      state.subAdminColumns = action.payload;
    },
    setSelectedSubAdminColumns: (state, action) => {
      state.selectedSubAdminColumns = action.payload;
    },
  },
});

// Export action creators and reducer
export const {
  setWebUserColumns,
  setSelectedWebUserColumns,
  setSubAdminColumns,
  setSelectedSubAdminColumns,
  setRolesAndPermissionsColumns,
  setSelectedRolesAndPermissionsColumns,
} = commonSlice.actions;

export default commonSlice.reducer;
